export default "__VITE_ASSET__b622ee3f__"